import { BooleanLiteral } from "typescript";
import { ClassSummary, Student, Vacation } from "./CalendarModels";
import { OptionSet } from "./OptionSet";
import { Schedule } from "./Schedule";
import { Schedule_ep } from "./Schedule_ep";
import { StudentSchedule } from "./StudentSchedule";

export class CalendarRequest {
    public constructor() {

    }
    public Action: string;
    public accountSchedule: Schedule_ep;
    public MonthForVacationsOfAccount: string;
    public VacationRequest: VacationRequest;
    public ContactNeedsId: string;
    public StudentScheduleRequest: StudentScheduleRequest;
    public ClassScheduleRequest: ClassScheduleRequest;
    public AuthorityStatusesRequest: AuthorityStatusesRequest;
    public StudentVacationRequest: StudentVacationRequest;
    public ClassVacationRequest: ClassVacationRequest;
    public BaseClassSchedule: BaseClassSchedule ;
}

export class AccountScheduleMain {

    constructor() {
        this.schedule_e = new AccountSchedule();
        this.schedule_p = new AccountSchedule();
    }
    public schedule_e: AccountSchedule;
    public schedule_p: AccountSchedule;
}

export class AccountSchedule {
    public Class: OptionSet;
    public ClassCode: OptionSet;
    public Sunday: OptionSet;
    public Monday: OptionSet;
    public Tuesday: OptionSet;
    public Wednesday: OptionSet;
    public Thursday: OptionSet;
    public Friday: OptionSet;
    public Saturday: OptionSet;
    public _Type: OptionSet;
    public Id: string;
}

export class VacationRequest {
    public Id: string;
    public ParentId: string;
    public ReturnTime: OptionSet;
    public Name: string;
    public IsShortDay: boolean;
    public StartTime: OptionSet;
    public EndTime: OptionSet;
    public FromDate: string;
    public ToDate: string;
    public Period: OptionSet;
    public Description: string;
    // public Color: OptionSet;
    public Dates: string[];
    public Class?: OptionSet;
    public ClassCode?: OptionSet;
    public Classification?: OptionSet;
    public Camp?: OptionSet;
    public Students?: Student[];
    public lastUpdatedByName?: string;
}

export class StudentScheduleRequest {
    public StudentsList: Student[];
    public Schedule: Schedule_ep;
    public UpdateMainSchedule: boolean;
}

export class ClassScheduleRequest {
    // public ClassesList?: OptionSet[];
    // public ClassCodesList?: OptionSet[];
    // public ClassificationList?: OptionSet[];
    public Schedule: Schedule_ep;
    public SchedulesToUpdate?: Schedule_ep[];
    public ClassesToCreate?: ClassSummary[];
    public StudentsToUpdate?: Student[];
    public UpdateMainSchedule: boolean;
}

export class StudentVacationRequest {
    public Vacation: VacationRequest;
    public Students: Student[];
}

export class ClassVacationRequest {
    public Vacation: VacationRequest;
    public ClassesToCreate: VacationRequest[];
    public VacationsToUpdate: VacationRequest[]
}

export class AuthorityStatusesRequest {
    public ItemId: string;
    public FilterName: string;
}
export class BaseClassSchedule {
    public Class: OptionSet;
    public ClassCode: OptionSet;
    public Classification: OptionSet;
}